import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetMyMemberPageOptions,
  GetMyMemberPageResponse,
  GetSiteMapOptions,
  GetSiteMapResponse,
  getMyMemberPage as universalGetMyMemberPage,
  getSiteMap as universalGetSiteMap,
} from './members-v1-santa-member-santa-member.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/members-area' };

export function getMyMemberPage(
  httpClient: HttpClient
): GetMyMemberPageSignature {
  return (options?: GetMyMemberPageOptions) =>
    universalGetMyMemberPage(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetMyMemberPageSignature {
  /**
   * Returns my member page
   */
  (options?: GetMyMemberPageOptions): Promise<
    NonNullablePaths<
      GetMyMemberPageResponse,
      | `result.head.noIndex`
      | `result.page`
      | `result.publicData.viewedUser._id`
      | `result.publicData.viewedUser.roles`
      | `result.status`,
      5
    >
  >;
}

export function getSiteMap(httpClient: HttpClient): GetSiteMapSignature {
  return (options?: GetSiteMapOptions) =>
    universalGetSiteMap(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetSiteMapSignature {
  /**
   * Returns site map
   * No permission as the request can be made by anything pretty much
   */
  (options?: GetSiteMapOptions): Promise<GetSiteMapResponse>;
}

export {
  AppData,
  Config,
  GetMyMemberPageOptions,
  GetMyMemberPageRequest,
  GetMyMemberPageResponse,
  GetSiteMapOptions,
  GetSiteMapRequest,
  GetSiteMapResponse,
  Head,
  MemberPageResult,
  Numbers,
  PageRole,
  Pattern,
  PublicData,
  RequestInfo,
  SantaMember,
  SeoData,
  ViewedUser,
} from './members-v1-santa-member-santa-member.universal.js';
